// extracted by mini-css-extract-plugin
module.exports = {"card":"newCases_card__1Qwwa"};